import styles from "./TermsCondition.module.css";

export default function UaeTermsContent() {
  return (
    <>
      <h3 className={styles.nextTitle}>Terms &amp; Conditions</h3>
      <p className={styles.nextParagraph}>
        These Terms and Conditions (&ldquo;Terms&rdquo;) govern your use of the
        services provided by Friends Travel and Tourism LLC (&ldquo;Company&rdquo;,
        &ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;), operating under
        the brand name Next Holidays. With the aid of reserving a trip through our
        website, you are deemed to have agreed to its terms of use. Please study
        the following phrases and processes with the intention of ensuring that
        you have simply understood the conditions of your chosen trip. All the
        underneath cited terms and conditions are relevant for bookings made
        through our websites, together with:
      </p>

      <h4 className={styles.nextSubheading}>1. Definitions</h4>
      <p className={styles.nextParagraph}>
        &ldquo;Customer&rdquo;, &ldquo;You&rdquo;, &ldquo;Your&rdquo; refers to
        the person using our Services.
      </p>
      <p className={styles.nextParagraph}>
        &ldquo;Services&rdquo; means travel-related products offered by our
        website, including but not limited to flight bookings, hotel reservations,
        holiday packages, transport arrangements, and allied travel services.
      </p>
      <p className={styles.nextParagraph}>
        &ldquo;Supplier/Partner&rdquo; means airlines, hotels, transport
        providers, insurance companies, and other third-party vendors.
      </p>

      <h4 className={styles.nextSubheading}>2. Use of Services</h4>
      <p className={styles.nextParagraph}>
        You must be at least 18 years old and legally competent to enter into
        contracts. You agree to provide accurate, complete, and up-to-date
        information during booking. You are responsible for maintaining the
        confidentiality of your account and booking credentials. Use of our
        Services for fraudulent, unlawful, or unauthorized purposes is strictly
        prohibited.
      </p>

      <h4 className={styles.nextSubheading}>3. Pricing</h4>
      <p className={styles.nextParagraph}>
        Our policy guarantees competitive pricing and the ease of online booking.
        Unless specified otherwise, the prices listed on our website are per
        person and exclude tips for tour guides or drivers, passport/visa fees,
        travel insurance, beverages or meals, accommodation, room services, and
        laundry. The listed rates are subject to change without prior notice,
        particularly in response to unforeseen circumstances, such as increased
        activity or transportation costs.
      </p>

      <h4 className={styles.nextSubheading}>4. Methods of Payment</h4>
      <p className={styles.nextParagraph}>
        We accept a wide range of credit cards, including Visa, MasterCard,
        American Express, Discover, and Diners Club. Full payment is required via
        credit card, and guests must provide their credit card number to complete
        the transaction. This will be confirmed as a charge on your statement.
      </p>

      <h4 className={styles.nextSubheading}>5. Confirmation of Payment</h4>
      <p className={styles.nextParagraph}>
        After the payment is processed, our tour consultants will email you a
        confirmation slip. You can present a printout of this slip as proof of
        payment to the service provider to redeem your tour package. Please make
        sure you have provided accurate information regarding your travel needs
        at the time of booking.
      </p>

      <h4 className={styles.nextSubheading}>
        6. Cancellation, No Display Policy &amp; Refund Processing
      </h4>
      <div className={styles.nestedSection}>
        <p className={`${styles.nextParagraph} ${styles.nextSubheading}`}>
          6.1 Cancellation
        </p>
        <p>
          Each tour activity/attraction has its own cancellation rules. Before
          booking any activity with us, the customer must review the cancellation
          policy of that specific tour. Combo tours can be cancelled, but if anyone
          cancels any single tour in the combo, they will not be able to avail of
          the combo offer. In this situation, we shall consider the individual
          tour charge of the non-cancelled tour and refund the remaining amount.
          Traveller visa fees are not refundable once payment is made on the
          website. When booking a combo, please ensure that all combo tour options
          are available. If not, you will only be able to enjoy the tours and
          services that you have selected.
        </p>

        <p className={`${styles.nextParagraph} ${styles.nextSubheading}`}>
          6.2 Refund Process Time
        </p>
        <p>
          It will take 10-15 working days for the processing of refund, which will
          be credited to your original payment method within 7 working days.
        </p>

        <p className={`${styles.nextParagraph} ${styles.nextSubheading}`}>
          6.3 No Show
        </p>
        <p>
          If you fail to show up for the tour, no refunds, either in part or in
          full, will be provided. The same condition applies in the case of unused
          tickets, sightseeing tours, car rentals, or chauffeur-driven services.
          Likewise, rescheduling cannot be allowed for confirmed tours, transfers
          to and from airports, and other travel-related services.
        </p>
      </div>

      <h4 className={styles.nextSubheading}>7. Cancellation Procedures</h4>
      <p className={styles.nextParagraph}>
        Prior to making a cancellation, we suggest you carefully read the
        cancellation policies that apply to your tour package. For the cancellation
        of all or any part of your reservation, ensure that you notify us in
        writing. Upon receiving your cancellation request, we will inform you by
        email, fax, or phone regarding the confirmation of the booking
        cancellation and the fee that must be paid. Company cannot be held
        accountable for any cancellation that has not been received from you or
        confirmed by us.
      </p>

      <h4 className={styles.nextSubheading}>8. Itinerary Amendments</h4>
      <p className={styles.nextParagraph}>
        Routings and offerings included in your package deal are subject to change
        based on local/weather conditions, airway schedules, and several other
        factors. Should this transpire, we will offer suitable options of similar
        cost, but depending on availability. At maximum, we announce changes in
        the itinerary, if any, before departure. Please note that we reserve the
        right to implement minor amendments to the itinerary at any time without
        compensation. Similarly, no compensation can be achieved in the event of a
        vis major, including flood and earthquake.
      </p>

      <h4 className={styles.nextSubheading}>9. Tour Documents</h4>
      <p className={styles.nextParagraph}>
        It is the responsibility of each guest to ensure that they carry documents
        applicable to a specific tour, such as a passport or a valid identity
        card. This is especially important for guests coming from a different
        country. No refund will be provided in the event of loss or lack of these
        relevant documents. Additionally, passengers, regardless of their
        nationality, are advised to check with their respective consulates for
        information on entry specifications before they plan to visit. Equally
        important is to inquire with your consulate regarding current visa and
        health requirements, as they are subject to change without prior notice.
      </p>

      <h4 className={styles.nextSubheading}>10. Website Usage Regulations</h4>
      <p className={styles.nextParagraph}>
        All content on this website, which includes the emblem, pictures, facts on
        the excursion bundle, pricing details, and other applicable info, is
        proprietary to Next Holidays. Hence, as a circumstance of this
        website&apos;s usage, you agree not to exploit this internet site or its
        content for any non-private, commercial, or illegitimate purposes.
      </p>

      <h4 className={styles.nextSubheading}>11. Delivery &amp; Transport Coverage</h4>
      <p className={styles.nextParagraph}>
        We will not deal with or provide any services or products to any OFAC
        (Office of Foreign Assets Control) sanctioned countries, or to any persons
        or entities blacklisted under the applicable laws of the United Arab
        Emirates.
      </p>

      <h4 className={styles.nextSubheading}>12. Governing Law and Jurisdiction</h4>
      <p className={styles.nextParagraph}>
        Any purchase, dispute, or claim arising out of or in connection with this
        website shall be governed and construed in accordance with the laws of the
        United Arab Emirates and subject to the exclusive jurisdiction of the
        courts of Dubai, UAE.
      </p>

      <h4 className={styles.nextSubheading}>13. Disclaimer</h4>
      <p className={styles.nextParagraph}>
        <b>Travel at Your Own Risk:</b> The information provided on this website
        is for general informational purposes only. While we strive to ensure the
        accuracy and reliability of the information, we make no representations or
        warranties of any kind, express or implied, about the completeness,
        accuracy, reliability, suitability, or availability concerning the
        website or the information, products, services, or related graphics
        contained on the website for any purpose. Any reliance you place on such
        information is therefore strictly at your own risk.
      </p>
      <p className={styles.nextParagraph}>
        <b>Changes to Itineraries and Prices:</b> Prices, itineraries, and
        availability of travel services are subject to change without notice. We
        are not responsible for any changes, delays, or cancellations by travel
        providers. We recommend checking with the respective providers for the
        most current information.
      </p>
      <p className={styles.nextParagraph}>
        <b>Third-Party Links:</b> Our website may contain links to other websites
        that are not operated or controlled by us. Please be aware that we are
        not responsible for the content or privacy practices of such other sites.
        We encourage our users to be aware when they leave our site and to read
        the privacy statements of any other site that collects personally
        identifiable information.
      </p>
      <p className={styles.nextParagraph}>
        <b>Third Party Disclosure:</b> We may share statistics and personal
        information between themselves and with companies that are related to us,
        including our international branches. Personal Information that you
        submit to our website may be disclosed to a third party, such as our
        suppliers, mailing houses, who are employed to provide some of our
        services, such to meet the purpose for which it was submitted.
      </p>
      <p className={styles.nextParagraph}>
        <b>Access, Accuracy, and Security:</b> We shall take reasonable steps to
        ensure that the personal information collected is accurate, complete, and
        up-to-date. You can access and request correction of any personal
        information concerning you at any time. You may also request that your
        personal information be deleted at any time. Any such requests should be
        made directly by contacting us. We shall take reasonable steps to protect
        personal information from misuse, loss and unauthorized access,
        modification, or disclosure.
      </p>
      <p className={styles.nextParagraph}>
        <b>Health and Safety:</b> We recommend that you consult with a qualified
        professional before traveling. We do not provide medical, legal, or other
        professional advice, and we urge you to seek professional assistance
        before making travel plans. Always follow local health and safety
        guidelines and regulations.
      </p>
      <p className={styles.nextParagraph}>
        <b>Copyright Notice:</b> 2024 Friends Travel and Tourism LLC. All rights
        reserved. The content, including but not limited to text, images,
        graphics, and logos, on this website is the property of Friends Travel
        and Tourism LLC and is protected by UAE copyright and intellectual
        property laws, as well as international treaties. Unauthorized use,
        reproduction, or distribution of the content is strictly prohibited
        without prior written consent from us.
      </p>
      <p className={styles.nextParagraph}>
        <b>Beware of Phishing Scams Stay Vigilant:</b> Phishing scams are
        fraudulent attempts to obtain sensitive information such as usernames,
        passwords, and credit card details by disguising themselves as a
        trustworthy entity in electronic communications. These scams often come in
        the form of fake emails, websites, or social media messages that mimic
        legitimate companies.
      </p>
      <p className={styles.nextSubheading}>How to Protect Yourself:</p>
      <p className={styles.nextParagraph}>
        <b>Verify the Source:</b> Always check the sender&apos;s email address and
        website URL to ensure they are from our official domain. Look for Security
        Indicators: Our official communications will always contain proper
        grammar, branding, and contact information. Be wary of unsolicited
        messages with urgent or threatening language.
        <br />
        <br />
        <b>Do Not Share Personal Information:</b> Never share your personal
        information, such as passwords or credit card details, via email or
        unsecured websites.
        <br />
        <br />
        <b>Contact Us Directly:</b> If you are unsure about the legitimacy of a
        communication, contact us directly through our official channels.
      </p>
      <p className={styles.nextParagraph}>
        <b>Reporting Phishing:</b> If you suspect you have received a phishing
        email or have been directed to a fraudulent website, please report it to
        us immediately at feedback.ind@nextholidays.com. We take such incidents
        seriously and will take appropriate action. All tours and services are
        provided in compliance with the applicable regulations of the Dubai
        Department of Economy and Tourism (DET) or other relevant UAE authorities.
      </p>

      <h4 className={styles.nextSubheading}>14. Caution</h4>
      <p className={styles.nextParagraph}>
        Beware of Fake Promotions or Offers. Please do not believe or engage with
        any promotional emails, SMS, or web link that asks you to click on a link
        and fill in your details. All authorized email communications are
        delivered from the domain nextholidays.com or nextholidays.co.in and Next
        Holidays bears no liability or responsibility whatsoever for any
        communication that is fraudulent or misleading in nature and not received
        from a registered domain.
      </p>

      <h4 className={styles.nextSubheading}>15. Tour Coverage</h4>
      <p className={styles.nextParagraph}>
        We strongly recommend that all customers obtain comprehensive travel
        insurance to cover medical expenses, trip cancellations, lost baggage, and
        other unforeseen events. Friends Travel and Tourism LLC shall not be
        liable for damages, losses, or expenses beyond its control.
      </p>
    </>
  );
}
